import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Table } from 'rsuite'

import notification from '../../utils/notification'
import { startLoading, doneLoading } from '../../utils/loading'
import { downloadInstallmentIncomeAttacthment } from '../../redux/actions/incomeAndExpense'
import IncomeRecordFileTable from './IncomeRecordFileTable'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { sessionGetItemJSON } from '../../utils/sessionHelpers'
import { getValueFromOptions, getDateThaiShort } from '../../utils/dataUtil'
import { budgetFormat } from '../../utils/formatterUtil'

export default function IncomeRecordView({ schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table

  const fileTableData = schema?.attachFiles?.values || []
  const periodInfo = sessionGetItemJSON('periodInfo')

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadInstallmentIncomeAttacthment(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadInstallmentIncomeAttacthment(fileObj.id)
      var fileName = fileObj.name

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={
          periodInfo && (
            <div style={{ textAlign: 'left' }}>
              <Col lg={12} md={12} sm={24} xs={24}>
                <span>{periodInfo?.periodNo + ' (' + periodInfo?.startAndEndDate + ')'}</span>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <span>
                  {'งวดที่ ' + periodInfo?.periodNumber + '/' + periodInfo?.periodOfLength}
                </span>
              </Col>
            </div>
          )
        }
      >
        <Row style={{ marginTop: 30 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {schema.voucherNumber.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${schema.voucherNumber.value || ''}`}</p>
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {schema.referenceNumber.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p> {` : ${schema.referenceNumber.value || ''}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {schema.accountChannel.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.accountChannel.value == 2 ? (
              <>
                <p>
                  {` : ${getValueFromOptions(
                    schema.accountChannel.options,
                    schema.accountChannel.value || '0'
                  )} ${schema.bankAccount.label} : ${getValueFromOptions(
                    schema.bankAccount.options,
                    schema.bankAccount.value
                  )}`}
                </p>
              </>
            ) : (
              <>
                <p>
                  {` : ${getValueFromOptions(
                    schema.accountChannel.options,
                    schema.accountChannel.value || '0'
                  )}`}
                </p>
              </>
            )}
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {schema.voucherDate.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${getDateThaiShort(schema.voucherDate.value)}`}</p>
          </Col>
        </Row>

        {schema.receiveAnnuity && (
          <>
            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {schema.accountChannelConfirm.label}
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <p>
                  {` : ${getValueFromOptions(
                    schema.accountChannelConfirm.options,
                    schema.accountChannelConfirm.value || '0'
                  )}`}
                </p>

                {(schema?.accountChannelConfirm?.value || 1) == '2' && (
                  <>
                    <p>
                      {` : ${getValueFromOptions(
                        schema.bankAccountConfirm.options,
                        schema.bankAccountConfirm.value || '0'
                      )}`}
                    </p>
                  </>
                )}
              </Col>
            </Row>
          </>
        )}

        <Row style={{ marginTop: 5 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {schema.receiveMoneyEtc.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {` : ${schema?.receiveMoneyEtcInfo?.name || ''}`}
          </Col>
        </Row>

        <Row style={{ marginTop: 5 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {schema.description.label}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <p>{` : ${schema.description.value || ''}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 25 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {schema.attachFiles.label || 'เอกสารแนบประกอบ'} {' : '}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {fileTableData.length > 0 && (
              <IncomeRecordFileTable
                data={fileTableData}
                deleteable={false}
                onPreview={onPreview}
                onDownload={onDownload}
              />
            )}
          </Col>
        </Row>

        {schema.receiveAnnuity && (
          <div>
            <Table
              wordWrap
              autoHeight
              // loading={loading}
              data={schema.receiveAnnuity.values}
              style={{ marginTop: 10 }}
            >
              <Column width={250} minWidth={250} flexGrow={1} height={75}>
                <HeaderCell>{schema.receiveAnnuity.categoryOfReceived}</HeaderCell>
                <Cell dataKey="name" />
              </Column>
              <Column width={200} style={{ textAlign: 'right' }}>
                <HeaderCell>{schema.receiveAnnuity.amount}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return budgetFormat(rowData['budget'])
                  }}
                </Cell>
              </Column>
              <Column width={200} style={{ textAlign: 'right' }}>
                <HeaderCell>{schema.receiveAnnuity.vat}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return budgetFormat(rowData['vat'])
                  }}
                </Cell>
              </Column>
              <Column width={200} style={{ textAlign: 'right' }}>
                <HeaderCell>{schema.receiveAnnuity.withholding}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return budgetFormat(rowData['withholding'])
                  }}
                </Cell>
              </Column>
            </Table>
          </div>
        )}
      </Panel>
    </>
  )
}
